module.exports = __webpack_public_path__ + "img/ternate-logo.4313afca.jpg";